import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import usePointHistory from "./usePointHistory";
import EmptyData from "../../../Global/EmptyData";
import OrderColumn from "../../../Global/OrderColumn";

const PointHistory = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    pointHistoryList,
    paginationOptions,
    pointHistoryState,
    handleEditColumnsClick,
    updatePointHistoryFields,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = usePointHistory();

  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={pointHistoryState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: pointHistoryState?.search }}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
        />
        {pointHistoryList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={pointHistoryList?.data?.result || []}
            uniqueID={"id"}
            fields={pointHistoryList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={pointHistoryState?.clearSelection}
            perpage={pointHistoryState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={pointHistoryList?.data?.fields || []}
              moduleId={pointHistoryList?.data?.module_id}
              updateData={updatePointHistoryFields}
            />
          </div>
        </ModalLayout>

        {pointHistoryList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={pointHistoryState?.currentPage}
            totalPageCount={Math.ceil(
              pointHistoryList.data.total_count /
                pointHistoryState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === pointHistoryState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
    </>
  );
};

export default PointHistory;
